import styles from "./SearchCover.module.css";

function SearchCover({ searchBarState, setSearchBarState, focus = false }) {
    function handleSearchCoverClick() {
        setSearchBarState(false);
    }

    return (
        <div
            id={styles.search_cover}
            className={[
                searchBarState ? "" : styles.hide,
                focus ? styles.focus : "",
            ].join(" ")}
            onClick={handleSearchCoverClick}
        ></div>
    );
}

export default SearchCover;
